import React, { JSX } from 'react';
import Page from '@/components/Layout/Page';
import { useCan } from '@/hooks/useRbac';
import { Card, CardContent } from './ui/card';
import EmptyLayoutWithLogoutFooter from './Layout/EmptyLayoutWithLogoutFooter';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { BilderitModuleId } from '@/generated/codegen';

export const MaybeUnpaidNoticePage: React.FC<{ children?: JSX.Element }> = ({
  children,
}) => {
  const can = useCan();
  const { isFeatureEnabled } = useFeatureFlags();

  if (isFeatureEnabled(BilderitModuleId.Pagaraprata) && !can('debug:view')) {
    return (
      <EmptyLayoutWithLogoutFooter>
        <Page>
          <Card className="w-1/2 m-auto">
            <CardContent>
              El servicio se encuentra interrumpido por falta de pago. Por favor
              comunícate con nosotros a{' '}
              <a href="mailto:info@bilderit.com">info@bilderit.com</a> para
              reanudar el servicio.
            </CardContent>
          </Card>
        </Page>
      </EmptyLayoutWithLogoutFooter>
    );
  } else {
    return <>{children}</>;
  }
};
